import Vue from 'vue'
import Router from 'vue-router'
import login from '@/views/login'
import dashboard from '@/views/dashboard'
import layout from '@/views/layout'
import rawData from '@/views/rawData'
import license from '@/views/license'
// import uba from '@/views/uba'
// import configChange from '@/views/configChange'
import generateUser from '@/views/generateUser'
import customerDetail from '@/views/customerDetail'
import allDashboard from '@/views/alldashboard'
import resetPassword from '@/views/resetPassword'
import notFound from '@/views/notFound'
import alert from '@/views/alert'
import monitor from '@/views/monitor'
import monitorVolume from '@/views/monitorVolume'
// import register from '@/views/register'
import jwtDecode from 'jwt-decode'
import whiteListPage from '@/views/whiteListPage'
import pdpacontrol from '@/views/pdpaControl'
// import alertHistoryTCCA from '@/views/alertHistoryTCCA'
import alertHistoryTCCA from '@/views/alertHistoryTCCA_new'
// import alertHistoryPDPA from '@/views/alertHistoryPDPA'
import alertHistoryPDPA from '@/views/alertHistoryPDPA_new'
import dashboardPDPA from '@/views/dashboardPDPA'
import adminControl from '@/views/adminControl'
import eventControl from '@/views/eventControl'
// import maintenance from '@/views/maintenance'
// import reqtuestFeature from '@/views/requestFeature.vue'
// import reportProblem from '@/views/reportProblem.vue'

Vue.use(Router)

let router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'login',
      // redirect: '/maintenance',
      component: login
    },
    // {
    //   path: '/operation',
    //   name: 'login',
    //   component: login
    // },
    // {
    //   path: '/maintenance',
    //   name: 'maintenance',
    //   component: maintenance
    // },
    {
      path: '/app',
      name: 'layout',
      component: layout,
      meta: {
        requiresAuth: true,
        roles: ['management', 'user', 'dashboard', 'AIS_Dashboard']
      },
      props: true,
      children: [
        {
          path: 'dashboard',
          name: 'dashboard',
          component: dashboard,
          meta: {
            requiresAuth: true,
            roles: ['management', 'user', 'dashboard', 'AIS_Dashboard']
          },
          props: true
        },
        {
          path: 'raw',
          name: 'raw',
          component: rawData,
          meta: {
            requiresAuth: true,
            roles: ['management', 'user', 'dashboard']
          },
          props: true
        },
        // {
        //   path: 'uba',
        //   name: 'uba',
        //   component: uba,
        //   meta: {
        //     requiresAuth: true,
        //     roles: ['management']
        //   },
        //   props: true
        // },
        // {
        //   path: 'configChange',
        //   name: 'configChange',
        //   component: configChange,
        //   meta: {
        //     requiresAuth: true,
        //     roles: ['management']
        //   },
        //   props: true
        // },
        {
          path: 'license',
          name: 'license',
          component: license,
          meta: {
            requiresAuth: true,
            roles: ['management', 'user', 'dashboard']
          },
          props: true
        },
        {
          path: 'generateUser',
          name: 'generateUser',
          component: generateUser,
          meta: {
            requiresAuth: true,
            roles: ['management']
          },
          props: true
        },
        {
          path: 'customerDetail',
          name: 'customerDetail',
          component: customerDetail,
          meta: {
            requiresAuth: true,
            roles: ['management']
          },
          props: true
        },
        {
          path: 'allDashboard',
          name: 'allDashboard',
          component: allDashboard,
          meta: {
            requiresAuth: true,
            roles: ['management', 'dashboard', 'AIS_Dashboard']
          },
          props: true
        },
        {
          path: 'monitor',
          name: 'monitor',
          component: monitor,
          meta: {
            requiresAuth: true,
            roles: ['management']
          },
          props: true
        },
        {
          path: 'monitorVolume',
          name: 'monitorVolume',
          component: monitorVolume,
          meta: {
            requiresAuth: true,
            roles: ['management']
          },
          props: true
        },
        {
          path: 'alert',
          name: 'alert',
          component: alert,
          meta: {
            requiresAuth: true,
            roles: ['management', 'user', 'dashboard']
          },
          props: true
        },
        // {
        //   path: 'register',
        //   name: 'register',
        //   component: register
        // },
        {
          path: 'whiteList',
          name: 'whiteList',
          component: whiteListPage,
          meta: {
            requiresAuth: true,
            roles: ['management', 'user'],
            pdpacontrol: true,
            settingpdpa: true
          },
          props: true
        },
        {
          path: 'pdpacontrol',
          name: 'pdpacontrol',
          component: pdpacontrol,
          meta: {
            requiresAuth: true,
            roles: ['management']
          },
          props: true
        },
        {
          path: 'alertHistorytcca',
          name: 'alertHistorytcca',
          component: alertHistoryTCCA,
          meta: {
            requiresAuth: true,
            roles: ['management', 'user']
          },
          props: true
        },
        {
          path: 'alertHistorypdpa',
          name: 'alertHistorypdpa',
          component: alertHistoryPDPA,
          meta: {
            requiresAuth: true,
            roles: ['management', 'user'],
            pdpacontrol: true
          },
          props: true
        },
        {
          path: 'dashboardpdpa',
          name: 'dashboardpdpa',
          component: dashboardPDPA,
          meta: {
            requiresAuth: true,
            roles: ['management', 'user'],
            pdpacontrol: true
          },
          props: true
        },
        // {
        //   path: 'request',
        //   name: 'request',
        //   component: reqtuestFeature,
        //   meta: {
        //     requiresAuth: true,
        //     roles: ['management', 'user']
        //   },
        //   props: true
        // },
        // {
        //   path: 'report',
        //   name: 'report',
        //   component: reportProblem,
        //   meta: {
        //     requiresAuth: true,
        //     roles: ['management', 'user']
        //   },
        //   props: true
        // },
        {
          path: 'support',
          name: 'support',
          component: adminControl,
          meta: {
            requiresAuth: true,
            roles: ['management']
          },
          props: true
        },
        {
          path: 'supportevent',
          name: 'supportevent',
          component: eventControl,
          meta: {
            requiresAuth: true,
            roles: ['management']
          },
          props: false
        }
      ]
    },
    {
      path: '/resetPassword',
      name: 'resetPassword',
      component: resetPassword,
      props: (route) => ({ token: route.query.token }),
      beforeEnter: (to, from, next) => {
        if (!to.query.token) {
          next({ name: 'notFound' })
        } else {
          next()
        }
      }
    },
    {
      path: '/notFound',
      name: 'notFound',
      component: notFound
    },
    {
      path: '*',
      redirect: { name: 'notFound' }
    }
  ]
})

router.beforeEach((to, from, next) => {
  if (to.meta.requiresAuth) {
    if (!sessionStorage.getItem('user-token')) {
      next({ name: 'login' })
    } else {
      let decoded = jwtDecode(sessionStorage.getItem('user-token')).role
      let pdpacontroldashboard = jwtDecode(sessionStorage.getItem('user-token')).pdpacontrol.dashboard
      let pdpacontrolsetting = jwtDecode(sessionStorage.getItem('user-token')).pdpacontrol.addlist
      if (to.meta.pdpacontrol) {
        if (to.meta.settingpdpa) {
          for (let x in to.meta.roles) {
            if (pdpacontroldashboard && pdpacontrolsetting) {
              if (decoded === to.meta.roles[x]) {
                next()
              }
            } else {
              next({ name: 'notFound' })
            }
          }
        } else {
          for (let x in to.meta.roles) {
            if (pdpacontroldashboard) {
              if (decoded === to.meta.roles[x]) {
                next()
              }
            } else {
              next({ name: 'notFound' })
            }
          }
        }
      } else {
        for (let x in to.meta.roles) {
          if (decoded === to.meta.roles[x]) {
            next()
          }
        }
      }
      // for (let x in to.meta.roles) {
      //   if (decoded === to.meta.roles[x]) {
      //     next()
      //   }
      // }
    }
  } else {
    next()
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js